/**
 * address Group
 * @param fb : FormBuilder
 */
export function addressesGroup (fb: any):any {
    return fb.group({
        name: [''],
        city: [''],
        zipcode: [''],
        streets: [[]],
        subDivision: ['']
    });
}
